import { MetricType } from '../../pages/Dashboard';
import { Leaf, Trash2, Trees } from 'lucide-react';

interface MetricToggleProps {
  selectedMetric: MetricType;
  onMetricChange: (metric: MetricType) => void;
}

export function MetricToggle({ selectedMetric, onMetricChange }: MetricToggleProps) {
  const metrics: {
    type: MetricType;
    label: string;
    icon: React.ReactNode;
    gradient: string;
    shadow: string;
  }[] = [
      {
        type: 'CO2e',
        label: 'CO₂e',
        icon: <Leaf className="w-4 h-4" />,
        gradient: 'bg-gradient-to-r from-[#0072CE] to-[#0052a3]',
        shadow: 'shadow-[0_4px_12px_rgba(0,114,206,0.3)]'
      },
      {
        type: 'Waste',
        label: 'Waste',
        icon: <Trash2 className="w-4 h-4" />,
        gradient: 'bg-gradient-to-r from-[#D97706] to-[#B45309]',
        shadow: 'shadow-[0_4px_12px_rgba(217,119,6,0.3)]'
      },
      {
        type: 'TreesSaved',
        label: 'Trees Saved',
        icon: <Trees className="w-4 h-4" />,
        gradient: 'bg-gradient-to-r from-[#10B981] to-[#059669]',
        shadow: 'shadow-[0_4px_12px_rgba(16,185,129,0.3)]'
      }
    ];

  const getButtonClasses = (metric: typeof metrics[0]) => {
    const isSelected = selectedMetric === metric.type;
    return `
      flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-all duration-300
      ${isSelected
        ? `${metric.gradient} text-white ${metric.shadow} scale-105`
        : 'text-gray-600 hover:bg-gray-50/80 hover:scale-102'
      }
    `;
  };

  return (
    <div className="flex gap-2 bg-white/80 backdrop-blur-xl border border-gray-200/50 rounded-xl p-1.5 shadow-[0_4px_20px_rgb(0,0,0,0.08)]">
      {metrics.map(metric => (
        <button
          key={metric.type}
          onClick={() => onMetricChange(metric.type)}
          className={getButtonClasses(metric)}
        >
          {metric.icon}
          <span>{metric.label}</span>
        </button>
      ))}
    </div>
  );
}
